import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const TrainPositionToolbar = ({ themeName, trainPositionAutoRefresh, changeTrainPositionAutoRefresh, popinfoId }) => {
  const handleTrainPositionAutoRefreshChange = async (e) => {
    await changeTrainPositionAutoRefresh(popinfoId, e.target.checked)
  }

  return (
    <div className="c-TrainPositionToolbar">
      <div className="c-TrainPositionToolbar-pane">
        <label className="c-TrainPositionToolbar-toggleButton">
          <input type="checkbox"
            checked={trainPositionAutoRefresh}
            onChange={handleTrainPositionAutoRefreshChange} />
          <span>
            <FormattedMessage id={trainPositionAutoRefresh ? "App.TrainPositions.disableAutoRefresh" : "App.TrainPositions.enableAutoRefresh"} />
          </span>
        </label>
      </div>
    </div>
  )
}

TrainPositionToolbar.propTypes = {
  themeName: PropTypes.string.isRequired,
  trainPositionAutoRefresh: PropTypes.bool.isRequired,
  changeTrainPositionAutoRefresh: PropTypes.func.isRequired,
  popinfoId: PropTypes.string,
}

export default TrainPositionToolbar
